import { FormInstance, message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { ProfileService } from '../services/profileService';

interface ProfileHandlersProps {
  form: FormInstance;
  navigate: NavigateFunction;
}

interface ProfileHandlersReturn {
  handleUpdate: () => Promise<void>;
}

const getProfileHandlers = ({ form, navigate }: ProfileHandlersProps): ProfileHandlersReturn => {
  const handleUpdate = async (): Promise<void> => {
    const loadingMessage = message.loading('Updating...', 0);
    const profile = form.getFieldsValue();
    const oldPassword = form.getFieldValue('old_password');
    const newPassword = form.getFieldValue('new_password');

    try {
      await ProfileService.updateProfile(profile);
    } catch (error) {
      console.error(error);
    }

    if (oldPassword || newPassword) {
      try {
        await ProfileService.updatePassword(form, oldPassword, newPassword);
      } catch (error) {
        console.error(error);
      }
    }
    loadingMessage();
    navigate('/');
  };

  return { handleUpdate };
};

export default getProfileHandlers;
